// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2XA9S","buttons":"Footer_buttons__2C0uH"};